import { useState } from 'react';
import type { FormValues } from './types';

export interface UseFormProps {
  values: {
    default: FormValues;
  };
}

export function useForm<T extends FormValues>(props: UseFormProps) {
  const [values, setValues] = useState<T>(props.values.default as T);

  return {
    values,
    setValues,
  };
}
